import { memo, ReactNode } from 'react';
import clsx from 'clsx';

import { SLIDE_MARGIN_RIGHT } from '../constants';

import styles from './styles.module.scss';

type CarouselSlidesProps = {
  slideItems: ReactNode[];
  currentIndex: number;
  classNames?: string;
};

const CarouselSlides = ({
  slideItems,
  currentIndex,
  classNames,
}: CarouselSlidesProps) =>
  slideItems.map((items, index) => (
    <li
      key={Math.random()}
      className={clsx(styles.item, classNames)}
      style={{ marginRight: `${SLIDE_MARGIN_RIGHT}px` }}
      data-testid="carousel-slide"
      // setting inert attribute directly won't work: https://github.com/WICG/inert/issues/58
      ref={(node) => {
        if (!node) return;

        if (currentIndex === index) {
          node.removeAttribute('inert');
          return;
        }

        node.setAttribute('inert', '');
      }}
    >
      {items}
    </li>
  ));

const MemoizedCarouselSlides = memo(CarouselSlides);

export default MemoizedCarouselSlides;
